import React, { useState } from "react"

import Heading from "./Heading"
import RichText from "./RichText"

import styles from "./faqgroup.module.scss"

const FAQ = ({ data }) => {
  const [isOpen, setIsOpen] = useState(false)

  const handleClick = () => {
    setIsOpen(!isOpen)
  }

  return(
    <li className={styles.item}>
      <h4
        className={(isOpen) ? styles.questionOpen : styles.question}
      >
        <button
          onClick={handleClick}
        >
          {data.question}
        </button>
      </h4>
      <div
        className={(isOpen) ? styles.answerOpen : styles.answer}
      >
        <RichText
          json={data.answer.json}
        />
      </div>
    </li>
  )
}

const FAQGroup = ({ data }) => {
  return(
    <section className={styles.group} id={data.heading.toLowerCase().replace(/\s/g,"-")}>
      <Heading
        tag="h3"
        level="3"
        className={styles.heading}
      >
        {data.heading}
      </Heading>
      <ul>
        {data.faqs.map((faq, i) => (
          <FAQ
            key={i}
            data={faq}
          />
        ))}
      </ul>
    </section>  
  )
}

export default FAQGroup
